import { Component, Input } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

import { MenuService, ModalService } from '../../../services';
import { DeleteModalComponent } from '../../modals';

@Component({
  selector: 'app-formly-repeat',
  templateUrl: './formly-repeat.component.html',
  styleUrl: './formly-repeat.component.scss',
})
export class FormlyRepeatComponent extends FieldArrayType {
  @Input() newAtTop = true;

  constructor(
    public menuService: MenuService,
    private modalService: ModalService,
  ) {
    super();
  }

  delete(index: number) {
    this.modalService.openSmall<DeleteModalComponent>(DeleteModalComponent).modal.result.then(
      () => this.remove(index),
      () => {},
    );
  }
}
